export const RELATION_COPY = {
  handles: {
    label: 'Handled by',
    help: 'Completing this task resolves the remedial.',
  },
  related: {
    label: 'Related',
    help: 'Connected to the remedial for context. Completing it does not resolve the remedial.',
  },
}

export const relationCopy = relation => RELATION_COPY[relation] || RELATION_COPY.related

export const sourceNote = source => (source === 'auto' ? 'Linked automatically' : null)

export const LINKS_EXPLAINER = '"Handled by" means completing the task resolves the remedial. "Related" tasks are linked for context only and never close the remedial.'

export const SUGGESTION_HELP = 'We think this task may already deal with the remedial, based on the wording, the location and when it was created. Check it, then link it or choose "Not this one".'

export const errorMessage = (err, fallback = 'That did not work. Please try again.') =>
  err?.response?.data?.errors
    ? Object.values(err.response.data.errors).flat()[0] || fallback
    : err?.response?.data?.message || fallback
